// Yjs relative-position <-> absolut offset. Returnerer null når et anker er kollapset
// (den ankrede tekst er slettet) -> fremhævningen forsvinder helt af sig selv (BYG-PLAN §7.2).
import * as Y from 'yjs';

export function resolveAnchor(anchor, doc) {
  if (!anchor || !anchor.start || !anchor.end) return null;
  try {
    const a = Y.createAbsolutePositionFromRelativePosition(Y.createRelativePositionFromJSON(anchor.start), doc);
    const b = Y.createAbsolutePositionFromRelativePosition(Y.createRelativePositionFromJSON(anchor.end), doc);
    if (!a || !b) return null;
    const from = Math.min(a.index, b.index);
    const to = Math.max(a.index, b.index);
    if (to <= from) return null;
    return [from, to];
  } catch { return null; }
}

// Byg et anker fra et absolut interval i en given Y.Text (til menneskelig kuratering).
export function makeAnchor(ytext, from, to) {
  return {
    start: Y.relativePositionToJSON(Y.createRelativePositionFromTypeIndex(ytext, from)),
    end: Y.relativePositionToJSON(Y.createRelativePositionFromTypeIndex(ytext, to)),
  };
}
